import { render, staticRenderFns } from "./allModule.vue?vue&type=template&id=6f8cb4d4&scoped=true&"
import script from "./allModule.vue?vue&type=script&lang=js&"
export * from "./allModule.vue?vue&type=script&lang=js&"
import style0 from "./allModule.vue?vue&type=style&index=0&id=6f8cb4d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8cb4d4",
  null
  
)

export default component.exports